import {GenericApi} from "./generic-api";
import {API} from "../api-endpoints";
import {BankDetails} from "../../pages/building/modals/bank-details";
import {BuildingData} from "../move-in-modal";

export class BuildingApi extends GenericApi {
    private static _instance: BuildingApi;

    public static get Instance(): BuildingApi {
        if (!this._instance) {
            this._instance = new BuildingApi();
        }
        return this._instance;
    }

    private constructor() {
        super(API.buildings);
    }

    public async getBankDetails(buildingName: string, data: BankDetails): Promise<BankDetails> {
        return this.postData<BankDetails>(`banking-details?buildingName=${buildingName}`, data);
    }

    public async updateFundiPassword(buildingName: string, password: string): Promise<void> {
        await this.postData(`fundi-password?buildingName=${buildingName}`, { password });
    }

    /**
     * Resolves with the server's confirmation line. The body is plain text, which Utils.post hands back
     * as {responseText}; the name arrives already URL-encoded, so it is not encoded again here.
     */
    async updateNsfasRates(buildingName: string, rate: number): Promise<string> {
        const response = await this.postData<any>(`rate/nsfas/${buildingName}?rate=${rate}`, {});
        return typeof response === 'string' ? response : (response?.responseText ?? '');
    }

    async signBuilding(buildingName: string, signature: string): Promise<string> {
        return this.postData<string>(`sign/${buildingName}`, { signature });
    }

    async deleteBuilding(buildingName: string): Promise<void> {
        await this.deleteData(`${buildingName}`);
    }

    async addUser(buildingName: string, email: string): Promise<void> {
        await this.postData(`users/add/${buildingName}?user=${encodeURIComponent(email)}`, {});
    }

    async removeUser(buildingName: string, userId: number): Promise<void> {
        await this.deleteData(`users/${buildingName}?user=${userId}`);
    }

    async getUserBuildings(): Promise<BuildingData[]> {
        return this.fetchData<BuildingData[]>(`user`);
    }

    async restoreBuilding(buildingId: number): Promise<void> {
        await this.postData(`restore/${buildingId}`, {});
    }
}